module.exports = __webpack_public_path__ + "static/media/MacPortrait2w990@1x.37ab5062.jpg";